module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-300italic.c076c489.woff2";